import { render, staticRenderFns } from "./storeTasks.vue?vue&type=template&id=4963b88b&scoped=true&"
import script from "./storeTasks.vue?vue&type=script&lang=js&"
export * from "./storeTasks.vue?vue&type=script&lang=js&"
import style0 from "./storeTasks.vue?vue&type=style&index=0&id=4963b88b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4963b88b",
  null
  
)

export default component.exports